import { Component, Inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Meta } from '@angular/platform-browser';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  url = 'https://www.workflow.space/';

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly meta: Meta
  ) {}

  ngOnInit() {
    if (environment.production) {
      this.meta.addTag({ name: 'robots', content: 'index, follow' });
      this.setCanonicalURL();
    }
  }

  setCanonicalURL(): void {
    const existingLink = this.document.querySelector("link[rel='canonical']");
    if (existingLink) {
      existingLink.setAttribute('href', this.url);
    } else {
      const link: HTMLLinkElement = this.document.createElement('link');
      link.setAttribute('rel', 'canonical');
      link.setAttribute('href', this.url);
      this.document.head.appendChild(link);
    }
  }
}
